import Http from '../../common/utils/Http';

export const fetchDashboardBankAccounts = async () => await Http.get('pr/funds/bankAccounts');
